export default __webpack_public_path__ + "static/media/Icons__snowflake.2b695a17.svg";